module.exports = __webpack_public_path__ + "img/Canoe_Kinda_canal.6632f044.jpg";